import { useMutation } from 'react-apollo';

import { sendUserAction as sendUserActionMutation } from '../../../graphql/mutations/analytics';
import { ANALYTICS_PLATFORMS } from '../../../constants/analytics';

const usePinterestTracking = () => {
  const [sendUserAction] = useMutation(sendUserActionMutation);

  const onTrackEvent = async ({ event, data }) => {
    if (!event) {
      return;
    }

    await sendUserAction({
      variables: {
        input: {
          analytics_platforms: [ANALYTICS_PLATFORMS.PINTEREST],
          event_name: event,
          platform: 'WEB',
          event_source_url: window.location.pathname,
          custom_data: data,
        },
      },
    });
  };

  return {
    onTrackEvent,
  };
};

export default usePinterestTracking;
